/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

// import { isNil } from 'lodash';
import isNil from 'lodash/isNil';
import { JSXElementConstructor, useEffect, useState } from 'react';
import idmRequest from '../../../lib/idmRequest';
import { isLoggedInSelector } from '../../../redux/loginSlice';
import styles from '../../../styles/FormLayout.module.css';
import myResStyles from '../../../styles/myResources.module.css';
import Loading from '../../02-molecules/Loading';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MessageType } from '../../modals/SuccessErrorModal';
// import _ from 'lodash';
import classnames from 'classnames';


const RoleDescriptionPage = () => {



  const [roleDescriptionData, setroleDescriptionData] = useState<any>();
  const [resNameGroupedData, setResNameGroupedData] = useState<any>();
  const [messagedesc, setMessagedesc] = useState('');
  const [isAlertOpendesc, setIsAlertOpendesc] = useState(false);
  const [expanded, setExpandeddesc] = useState<string | false>(false);
  const [message, setMessage] = useState<string |null>("");

  const header: string = "additional resources"
  // const subHeader:string = "Lorem Ipsum"
  const subHeaderDescription: string = "Below are descriptions of all available resources. If a resource looks applicable to you, navigate to “New Request” tab to submit a request. <br> <br> <b> Note: </b> Some may be dependent on the Engine Models associated to your company / individual profile, as well as the unique vendor / payer code. <br><br>"

  useEffect(() => {
    (async () => {
      try {
        await getRoleStatusList();
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  const getRoleStatusList = async () => {
    const data = await idmRequest('/endpoint/getUserRolesList?callFor=RoleDescription', 'get');
    console.log("data",data)
    if (!isNil(data)) {
      console.log(data)
      const groupedDescription= new Map<string,any>();
      data.roleDescriptions.forEach((info:any)=>{ 
        const key = info.resourceName
        const values = groupedDescription.get(key);
        if(!values){
          groupedDescription.set(key,[info])
        } else {
          values.push(info)
        }
      })
      setIsAlertOpendesc(false)
      setroleDescriptionData(data);
      setResNameGroupedData(groupedDescription)
    }
    else {
      setIsAlertOpendesc(true);
      setMessage('Failed to load Role Description');
    }
  }
  console.log("resNameGroupedData",resNameGroupedData)
  

  const handleOpen = () => {
    setIsAlertOpendesc(true);
  };
  const handleClose = () => {
    setIsAlertOpendesc(false);
  };


  const handleChange =
  (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpandeddesc(isExpanded ? panel : false);
  };

  const getResourceNameAccordian = () => {
    let uiElement: JSX.Element = <></>;
    let children: JSX.Element[] = [];
  
    if(!isNil(resNameGroupedData)){

      for (const [key, value] of resNameGroupedData) { 
        children.push(
          
            <Accordion expanded={expanded === key} onChange={handleChange(key)} className={myResStyles.accordianHead}>
              <AccordionSummary 
              className={classnames(`${myResStyles.accordianMain}`, {
                [myResStyles.accordianMainDark]: expanded === key,
              })}
                expandIcon={
                      <ExpandMoreIcon 
                       style={{color:"#5B6376"}}/>
                    } 
                aria-controls="panel1bh-content" 
                id="panel1bh-header" >
                <Typography className={classnames(`${myResStyles.topographySummaryDesc}`, {
                                        [myResStyles.topographySummaryDescExpanded]: expanded === key,
                                        })} sx={{ flexShrink: 0 }}>
                  <p className={classnames(`${myResStyles.resourceNameStyle}`, {
                                  [myResStyles.resourceNameStyleExpanded]: expanded === key,
                  })}
                   title={key}>{key}</p>
                  {(value.length === 1) ? <p className={classnames(`${myResStyles.rolesCount}`, {
                                                        [myResStyles.rolesCountExpanded]: expanded === key,})}
                  >{`${value.length} Role`}</p> : <p className={myResStyles.rolesCount}>{`${value.length} Roles`}</p>}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                  {getRoleDescripitons(value)} 
              </AccordionDetails>
              
            </Accordion>
          
        );
      }   
            uiElement = <div>{children}</div>;
            return uiElement;
    }
    else{
      return <></>;
    }
  }





  const getRoleDescripitons = ( values : any) => {
    let uiElement: JSX.Element = <></>;
    let children: JSX.Element[] = [];
    
    // console.log("roleDescription",roleDescriptionData)
    // console.log("roleDescription data",roleDescriptionData?.roleDescriptions)
  
    if(!isNil(values)){
      values.forEach((info: any) => {
              
              console.log("info",info);
              children.push(
                <div className={myResStyles.rolesContainer}>
                  <div className={myResStyles.roleName}>
                  {info.name}
                  </div>
                  <div className={myResStyles.roleDescription}>
                  {info.description}
                  </div>
                </div>
              );
            });


            uiElement = <div>{children}</div>;
            return uiElement;
    }
    else{
      return <></>;
    }
  }
  return (
    <>
      <div className={styles.container}>
        <main className={styles.mainrolerequest}>
          <div className={styles.headerGroup}>
            {header && (<h4 className={`brand-voice ${styles.header}`} dangerouslySetInnerHTML={{ __html: header }}></h4>)}
            {/* {subHeader &&(<div className={styles.subHeaderlable} dangerouslySetInnerHTML={{ __html: subHeader }}></div>)} */}
            {subHeaderDescription && subHeaderDescription && (<div className={styles.subHeaderDescription} dangerouslySetInnerHTML={{ __html: subHeaderDescription }}></div>)}
            <div className={myResStyles.border}>
              {
                roleDescriptionData ?
                <>{getResourceNameAccordian()}</> : 
                // <Loading size={100}></Loading> 
                <div style={{ marginTop: '10px', marginBottom: '40px' , border :'1px solid white'}} className="lowHeight">
                  <Loading size={100}/>
                </div>
              }
            </div>
          </div>
        </main>
      </div>
    </>
  );

};

export default RoleDescriptionPage;